<template>
  <section>
    <div class="form-card">
      <section class="sub-step-container">
        <span class="sub-step-item"
              :style="smallStep >= step ? 'background-color: var(--bids);' : 'background-color: var(--text-primary-color-alpha-2);'"
              :class="smallStep === step ? 'active-small-step' : 'inactive-small-step'"
              v-for="step in totalSmallSteps"
              :key="step"></span>
      </section>
      <b-overlay
        :show="loading"
        rounded
        opacity="0.6"
        spinner
        spinner-variant="primary"
        class="registration-steps-container"
        @hidden="!loading">
        <form action="/user/register" method="POST" id="registration-form-personal">
<!--          <transition name="fade">-->
            <input type="hidden" name="_token" :value="csrf" />
            <customer-type v-show="smallStep === 1"
                           @next="getCustomerType"></customer-type>
            <parenting-info v-show="customer === 'child' && smallStep === 2"
                            @next="getParentingInfo"
                            @previous="smallStep--"></parenting-info>
            <general-information-form v-show="(smallStep === 2 && customer === 'individual') || (smallStep === 3 && customer === 'child')"
                                      @lastname="getLastname"
                                      @firstname="getFirstname"
                                      @previous="smallStep--"
                                      :email="email"
                                      :customer-type="customer === 'individual'"
                                      @next="getPersonalInformation"></general-information-form>
            <address-form v-show="(smallStep === 3 && customer === 'individual') || (smallStep === 4 && customer === 'child')"
                          :statusofaddress='statusofaddress'
                          @next="getAddress"
                          @previous="smallStep--"></address-form>
            <account-info v-show="(smallStep === 4 && customer === 'individual') || (smallStep === 5 && customer === 'child')"
                          :banks="banks"
                          :account-name="this.firstname"
                          :is-child="customer === 'child'"
                          @next="getAccountInfo"
                          @previous="smallStep--"></account-info>
            <employment-info v-show="customer === 'individual' && smallStep === 5"
                             @next="getEmploymentInfo"
                             @previous="smallStep--"></employment-info>
            <financial-info v-show="customer === 'individual' && smallStep === 6"
                             @next="getFinancialInfo"
                            @previous="smallStep--"></financial-info>
            <pip-info v-show="customer === 'child' ? smallStep === 6 : smallStep === 7"
                      @next="getPipInfo"
                      @previous="smallStep--"></pip-info>
            <password-confirmation v-show="customer === 'child' ? smallStep === 7 : smallStep === 8"
                     @next="getPassword"
                     @previous="smallStep--"></password-confirmation>
<!--          </transition>-->
        </form>
      </b-overlay>
    </div>

<!--    <section class="d-flex justify-content-center mt-5">-->
<!--      <ic-button size="tn" color="grey" @click="previous()" class="d-flex align-items-center mr-3"><i class="sr sr-chevron-left"></i>Буцах</ic-button>-->
<!--      <ic-button size="tn" type="submit" variant="success"  @click="next()" class="d-flex align-items-center ml-3">Дараах <i class="sr sr-chevron-right"></i></ic-button>-->
<!--    </section>-->
  </section>
</template>

<script>
import CustomerType from './CustomerType'
import GeneralInformationForm from './GeneralInformationForm'
import AddressForm from './AddressForm'
import AccountInfo from './AccountInfo'
import EmploymentInfo from './EmploymentInfo'
import FinancialInfo from './FinancialInfo'
import ParentingInfo from './ParentingInfo'
import PipInfo from './PipInfo'
import PasswordConfirmation from './PasswordConfirmation'
import {mapState} from "vuex";

export default {
  components: {
    CustomerType,
    GeneralInformationForm,
    AddressForm,
    AccountInfo,
    EmploymentInfo,
    FinancialInfo,
    ParentingInfo,
    PipInfo,
    PasswordConfirmation,
  },
  props: {
    email: {
      type: String,
    },
    csrf: {
      type: String,
    },
    statusofaddress: {
      type: Object,
    },
    banks: {
      type: Object,
    },
    startSmallStep: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      smallStep: this.startSmallStep,
      totalSmallSteps: 8,
      loading: false,
      customer: null,
      lastname: '',
      firstname: '',
    }
  },
  computed: {
    fullName() {
      return `${this.firstname} ${this.lastname}`
    },
    ...mapState('user', ['danState']),
  },
  mounted() {
    if(this.danState === true)
      this.customer = 'individual'
  },
  watch: {
    customer() {
      if (this.customer === 'child') {
        this.totalSmallSteps = 7
      } else {
        this.totalSmallSteps = 8
      }
    }
  },
  methods: {
    getLastname(value) {
      this.lastname = value
    },
    getFirstname(value) {
      this.firstname = value
    },
    previous() {
      this.$emit('previous');
    },
    next() {
      this.$emit('next')
    },
    getCustomerType(value) {
      this.customer = value.customerType
      this.smallStep++
    },
    getPersonalInformation(value) {
      console.debug(value)
      this.smallStep++
    },
    getAddress(value) {
      this.smallStep++
    },
    getAccountInfo(value) {
      this.smallStep++
    },
    getEmploymentInfo(value) {
      this.smallStep++
    },
    getFinancialInfo(value) {
      this.smallStep++
    },
    getParentingInfo(value) {
      this.smallStep++
    },
    getPipInfo(value) {
      this.smallStep++
    },
    getPassword(value) {
      this.smallStep++
    }
  },
}
</script>

<style lang='scss'>
.form-card {
  border-radius: 1rem;
  background-color: var(--trading-screen-bg-color);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  padding: 2rem;
  &-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
    label {
      color: var(--text-grey-color);
      font-size: var(--text-body-3-size);
      font-weight: var(--text-body-3-weight);
      line-height: var(--text-body-3-line-height);
    }
  }
  &-header {
    color: var(--text-primary-color);
    font-size: var(--text-title-3-size);
    font-weight: var(--text-title-3-weight);
    line-height: var(--text-title-3-line-height);
    margin-bottom: 2rem;
  }
}
.sub-step {
  &-container {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    gap: 1rem;
  }
  &-item {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    transition: all .2s ease-in-out;
  }
}
.active-small-step {
  box-shadow: 0 0 0 6px rgba(var(--rgb-system-green), .3);
}
@media (max-width: 768px) {
  .form-card {
    padding: 0.5rem;
    box-shadow: none;
    &-form {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    &-header {
      text-align: center;
    }
  }
  .sub-step {
    &-container {
      padding-top: 2rem;
      margin-bottom: 1rem;
      justify-content: center;
    }
    &-buttons-container {
      margin-bottom: 1rem;
    }
  }
}
</style>